import { Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { REGISTRY } from '@/designs-dev/inspect/ds-registry';

// The component's name, doubling as the "view in action" affordance: when the
// component has an authored demo route it renders as a link that jumps to where
// it renders live and auto-selects it (?select=); otherwise it's plain text.
// Shared by the changelog and the Promotions board so the name itself is the
// link — no separate column. A linked name reads as a link (colour + hover
// underline); a plain one means "no directly-viewable screen".
export const ComponentNameLink = ({
  name,
  href,
}: {
  name: string;
  // Explicit route to link to (e.g. a handover page). When omitted, falls back
  // to the component's authored demo route.
  href?: string;
}) => {
  const demo = REGISTRY[name]?.demo;
  // A demo route can carry a scene of its own — a component that only renders
  // partway through a conversation has no screen to link to otherwise — so the
  // select is appended to whatever query the route already has.
  const select = demo ? `select=${demo.select ?? name}` : null;
  const to =
    href ??
    (demo && select
      ? `${demo.route}${demo.route.includes('?') ? '&' : '?'}${select}`
      : null);
  const label = (
    <Typography component='span' variant='body2'>
      {name}
    </Typography>
  );
  if (!to) return label;
  return (
    <Link component={RouterLink} to={to} underline='hover'>
      {label}
    </Link>
  );
};

export default ComponentNameLink;
